import React, { useEffect } from "react";
import CustomCard from "../../../components/Common/CustomCard";
import config from "../../../config";
import CompletedIcon from "../../../assets/images/lystfacelogos/CompletedIcon.svg"
import { useDispatch, useSelector } from "react-redux";
import PendingIcon from "../../../assets/images/lystfacelogos/PendingIcon.svg"
import { Link } from "react-router-dom";
import { closeGetStartedSection, getPlanSpecificationDetails } from "../../../store/menu/home/actions";
import { setPayementInformation } from "../../../store/actions";
import CrossIcon from "../../../assets/images/lystfacelogos/CrossIcon.svg"

const HelpDocumentsDescription = ({ dispatch, frstApiCl, trial_act }) => {
    const ConstDetailsProp = useSelector(state => state.Login.constDetails)
    const { card_setup, billing_setup } = ConstDetailsProp
    const AppListState = useSelector(state => state.Home?.appsListDetails)
    const { appListCount, responseCode: appListFetched } = AppListState
    const BillSetState = useSelector(state => state.BillSet);



    const dummyData = [
        { 'title': 'Add billing details', 'subtitle': 'Please add your billing address and card details', 'linkText': card_setup && billing_setup ? 'Setup completed' : 'Set up payment informations', 'link': '/settings/billing-details', completed: card_setup && billing_setup, fetchedStatus: true, disabled: false },
        { 'title': 'Add application', 'subtitle': 'Add your application and generate your API key', 'linkText': appListCount > 0 ? 'Application added' : 'Add application', 'link': '/application/add-application', completed: appListCount > 0, fetchedStatus: appListFetched, disabled: !card_setup },
        { 'title': 'Make your first API call', 'subtitle': 'Using the App ID and App key make your API call.', 'linkText': 'Refer API documents', 'link': config.urls.apiDocUrl, 'redirectNewPage': true, completed: frstApiCl, fetchedStatus: true, disabled: appListCount === 0 }

    ]
    const PlanUserState = useSelector(state => state.Plan)
    const { planAddLoading } = PlanUserState


    // useEffect(() => {
    //     if (!planAddLoading && card_setup && (trial_act === null || trial_act === undefined)) {
    //         dispatch(getPlanSpecificationDetails({}))
    //     }
    // }, [planAddLoading, card_setup, trial_act])

    const onClickBilling = () => {
        dispatch(setPayementInformation({ from: "payment-information" }))

    }
    return (
        <div className="help-documents-description-container">
            {dummyData.map((ele, i) =>
                <div className={`help-documents-field ${ele?.disabled ? "disabled" : ""}`} key={i}>
                    <div className="status-container">
                        <span className="title">{ele.title}</span>
                        {(ele.fetchedStatus && !ele.disabled) ?
                            ele.completed ?
                                < img className="status" src={CompletedIcon} />

                                :
                                <div className="pending-icon-animation"></div>
                            : null
                        }
                    </div>
                    <span className="subtitle">{ele.subtitle}</span>
                    {(ele.completed && !ele.redirectNewPage) ?
                        <span className="link-disabled">{ele.linkText}</span>
                        :
                        ele.disabled ?
                            <span className="link">{ele.linkText}</span>

                            :
                            ele.link === "/settings/billing-details" ?
                                <Link className="link" to={`${ele?.link}`} target={ele?.redirectNewPage ? "_blank" : ""}>
                                    <span onClick={onClickBilling}>
                                        {ele.linkText}

                                    </span>
                                </Link>
                                :

                                <Link className="link" to={`${ele?.link}`} target={ele?.redirectNewPage ? "_blank" : ""}>{ele.linkText}</Link>

                    }
                </div>

            )}
        </div>
    )

}




const HelpDocuments = ({ setClosed }) => {
    const dispatch = useDispatch();
    const GetStartedState = useSelector(state => state.Home?.getStarted)
    const { loading: closeStartedLoading } = GetStartedState
    const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails?.plan)
    const { frstApiCl, trial_act } = planSpecificaionState

    const handleCloseStartedSection = () => {
        setClosed(true)
        dispatch(closeGetStartedSection({ check: true }))
    }

    let buttonDetails = [
        { 'buttonText': 'API document', buttonType: 'secondary', path: config.urls.apiDocUrl, redirectNewPage: true, },

    ]
    if (frstApiCl) {
        buttonDetails = [
            { 'buttonText': 'API document', buttonType: 'secondary', path: config.urls.apiDocUrl, redirectNewPage: true, },
            { 'buttonText': 'closeGetStarted', buttonType: 'icon', buttonIcon: CrossIcon, path: null, 'callBackFunction': handleCloseStartedSection },

        ]
    }


    return (
        <React.Fragment>
            <CustomCard
                titleText={"Get started"}
                buttonsList={buttonDetails}
            >
                <HelpDocumentsDescription dispatch={dispatch} frstApiCl={frstApiCl} trial_act={trial_act}
                />
            </CustomCard>
        </React.Fragment>
    );
};

export default HelpDocuments;